import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getPaginationRange, DOTS } from '../pagination.util';
import PaginatorStyle, {
  PaginationWrapper,
  PaginationItem,
  MoveIcon,
  ArrowBlock,
  Dots,
} from '../paginator.style';

const Paginator = (props) => {
  const { onPageChange, totalCount, siblingCount, currentPage, pageSize, className } = props;

  const paginationRange = getPaginationRange({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];
  return (
    <PaginationWrapper className={` ${className}`}>
      <MoveIcon
        className={`move-icon prev-page ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={onPrevious}
        aria-hidden="true"
      >
        <ArrowBlock className="arrow left" />
      </MoveIcon>
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <Dots className="dots">&#8230;</Dots>;
        }

        return (
          <PaginationItem
            key={pageNumber}
            className={`pagination-item ${pageNumber === currentPage ? 'selected' : ''}`}
            onClick={() => onPageChange(pageNumber)}
            aria-hidden="true"
          >
            {pageNumber}
          </PaginationItem>
        );
      })}
      <MoveIcon
        className={`move-icon next-page ${currentPage === lastPage ? 'disabled' : ''}`}
        onClick={onNext}
        aria-hidden="true"
      >
        <ArrowBlock className="arrow right" />
      </MoveIcon>
    </PaginationWrapper>
  );
};

Paginator.propTypes = {
  onPageChange: PropTypes.func,
  totalCount: PropTypes.number,
  siblingCount: PropTypes.number,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  className: PropTypes.string,
};

Paginator.defaultProps = {
  className: 'pagination-bar',
  totalCount: 0,
  currentPage: 1,
  siblingCount: 1,
  pageSize: 0,
  onPageChange: () => {},
};

export default withStyles(Paginator, PaginatorStyle);
export { Paginator as PaginatorVanilla };
